//
//  api.ts
//
//  isana.net,inc. Proprietary and Confidential
//
import axios from "axios";
import { API_URL } from "../../utils/env";

export const verifyGhaToken = async (
  token: string
): Promise<{ healthUserId: string }> => {
  const path = `${API_URL}/googlehealth/verify-token`;
  return axios
    .post(path, { token }, { timeout: 10000 })
    .then((res) => ({ healthUserId: res.data.healthUserId }));
};

export const getTenantUserInfo = async (
  healthUserId: string
): Promise<{ exists: boolean }> => {
  const path = `${API_URL}/tenant/userinfo`;
  return axios
    .get(path, { params: { healthUserId }, timeout: 10000 })
    .then((res) => ({ exists: res.data.exists }));
};

export const postTenantUserInfo = async (
  healthUserId: string,
  fitinsightUniqueId: string,
  belongingGroup: string
): Promise<{ message: string }> => {
  const path = `${API_URL}/tenant/userinfo`;
  return axios
    .post(
      path,
      { healthUserId, fitinsightUniqueId, belongingGroup },
      { timeout: 10000 }
    )
    .then((res) => ({ message: res.data.message }))
    .catch((error) => {
      console.error(
        `POST /tenant/userinfo failed: status=${error.response?.status}`
      );
      const message = error.response?.data?.message ?? "連携処理に失敗しました";
      throw new Error(message);
    });
};

// 登録状態（New=新規 / Existing=既存(移行) / Registered=連携済み /
// Reactivate=解除済み(isUsed=false)からの再連携＝再有効化が必要）。
// 値はサーバAPIレスポンスの status 文字列と一致させる。
export enum RegistrationStatus {
  New = "new",
  Existing = "existing",
  Registered = "registered",
  Reactivate = "reactivate",
}

// E1-5: token から登録状態を判定する（新規/既存/連携済みの画面出し分け用）。
// 識別子はサーバ側でJWTから導出されるため、token のみ渡す。
export const getRegistrationStatus = async (
  token: string
): Promise<{
  healthUserId: string;
  status: RegistrationStatus;
  userInfo?: { fitinsightUniqueId: string; belongingGroup: string };
}> => {
  const path = `${API_URL}/tenant/userinfo/status`;
  return axios.post(path, { token }, { timeout: 10000 }).then((res) => ({
    healthUserId: res.data.healthUserId,
    status: res.data.status as RegistrationStatus,
    userInfo: res.data.userInfo,
  }));
};

// E1-5: 既存(Fitbit時代)被験者の移行を実行する（healthUserId追記＋旧Fitbitトークン削除＋有効化）。
export const migrateUserInfo = async (
  token: string
): Promise<{ message: string }> => {
  const path = `${API_URL}/tenant/userinfo/migrate`;
  return axios
    .post(path, { token }, { timeout: 10000 })
    .then((res) => ({ message: res.data.message }))
    .catch((error) => {
      console.error(
        `POST /tenant/userinfo/migrate failed: status=${error.response?.status}`
      );
      const message = error.response?.data?.message ?? "連携処理に失敗しました";
      throw new Error(message);
    });
};
